module.exports = __webpack_public_path__ + "img/s21.79029267.png";